import { render, staticRenderFns } from "./sysDict.vue?vue&type=template&id=c4bf6946&"
import script from "./sysDict.vue?vue&type=script&lang=js&"
export * from "./sysDict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports